// ------------------------------------------------------------------------footer accordion------------------------
// ------------------------------------------------------------------------footer accordion with plus/minus------------------------
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 749) { // Mobile only
    const blocks = document.querySelectorAll('.footer-block');

    blocks.forEach(block => {
      const heading = block.querySelector('.footer-block__heading');
      if (heading) {
        heading.addEventListener('click', function() {
          block.classList.toggle('active');
        });
      }
    });
  }
});


// ----------------------------------------product page products slider-------------------------
document.querySelectorAll('.cus-prd-coll-tbs-bv--section').forEach((section) => {
  section.flickityInstances = {};
  section.querySelectorAll('.cus-prd-coll-tbs-bv--pane .js-flickity').forEach(slider => {
    const pane = slider.closest('.cus-prd-coll-tbs-bv--pane');
    const wasHidden = pane.style.display === 'none' || getComputedStyle(pane).display === 'none';
    if (wasHidden) pane.style.display = 'block';

    section.flickityInstances[pane.id] = new Flickity(
      slider,
      JSON.parse(slider.dataset.flickity)
    );
    if (wasHidden) pane.style.display = '';
  });

  section.querySelectorAll('.cus-prd-coll-tbs-bv--tab').forEach((tab) => {
    tab.addEventListener('click', function () {
      section.querySelectorAll('.cus-prd-coll-tbs-bv--tab').forEach(t => t.classList.remove('active'));
      section.querySelectorAll('.cus-prd-coll-tbs-bv--pane').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      const activePane = section.querySelector('#' + this.dataset.tab);
      activePane.classList.add('active');
      if (section.flickityInstances[activePane.id]) {
        section.flickityInstances[activePane.id].resize();
      }
    });
  });
});

// -----------------------------------------badge prview image ------------------------
document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('cusBadgeOverlay');
  const overlayImg = document.getElementById('cusBadgePreviewImg');
  const closeBtn = document.getElementById('cusBadgeClose');

  document.querySelectorAll('.cus-badge-preview-trigger').forEach(trigger => {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      const img = this.dataset.img;
      if(!img) return;
      overlayImg.src = img;
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeOverlay(){
    overlay.classList.remove('is-visible');
    overlayImg.src = '';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeOverlay);
  overlay.addEventListener('click', function(e){
    if(e.target === overlay) closeOverlay();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeOverlay();
  });
});
// -----------------------------------------------new---------------triger-code-------------

document.addEventListener('click', function (e) {
const trigger = e.target.closest('.energy-label-trigger');
if (!trigger) return;

  e.preventDefault();

  const overlay = document.getElementById('cusBadgeOverlay');
  const overlayImg = document.getElementById('cusBadgePreviewImg');

  const img = trigger.dataset.labelUrl;
  if (!img) return;

  overlayImg.src = img;
  overlay.classList.add('is-visible');
  document.body.style.overflow = 'hidden';
});


// -----------------------------------------------------cus-tabs-products-sec----------------------------
document.addEventListener('DOMContentLoaded', function(){
  const tabs = document.querySelectorAll('.cus-led-pr-tbs--tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', function(){
      const tabID = this.getAttribute('data-tab');
      document.querySelectorAll('.cus-led-pr-tbs--tab').forEach(t=>t.classList.remove('active'));
      document.querySelectorAll('.cus-led-pr-tbs--content').forEach(c=>c.classList.remove('active'));
      this.classList.add('active');
      document.getElementById(tabID).classList.add('active');
    })
  })
})

// ---------------------------------------------------------------------------cus-mega-menu-----------------------------
document.addEventListener("DOMContentLoaded", function(){
const menu = document.querySelector(".cus-mg-head--menu");
const leftBtn = document.querySelector(".cus-mg-scroll-left");
const rightBtn = document.querySelector(".cus-mg-scroll-right");
function updateButtons(){
  if(menu.scrollLeft <= 0){
    leftBtn.style.display = "none";
  }else{
    leftBtn.style.display = "block";
  }
  if(menu.scrollLeft + menu.clientWidth >= menu.scrollWidth - 5){
    rightBtn.style.display = "none";
  }else{
    rightBtn.style.display = "block";
  }
}
rightBtn.addEventListener("click", function(){
  menu.scrollBy({
    left: menu.clientWidth,
    behavior: "smooth"
  });
});
leftBtn.addEventListener("click", function(){
  menu.scrollBy({
    left: -menu.clientWidth,
    behavior: "smooth"
  });
});
menu.addEventListener("scroll", updateButtons);
updateButtons();
});


// ------------------------------------------------product page prev and next ------------------------

document.addEventListener("DOMContentLoaded", async function () {
  const { currentHandle, collectionHandle } = window.productData;
  let products = [];

  async function getAllProducts(page = 1) {
    const res = await fetch(`/collections/${collectionHandle}/products.json?limit=250&page=${page}`);
    const data = await res.json();

    if (data.products.length) {
      products = products.concat(data.products);

      if (data.products.length === 250) {
        await getAllProducts(page + 1);
      }
    }
  }

  function setNavigation() {
    const index = products.findIndex(p => p.handle === currentHandle);
    if (index === -1) return;

    let prev = index - 1;
    let next = index + 1;

    if (prev < 0) prev = products.length - 1;
    if (next >= products.length) next = 0;

    const prevProduct = products[prev];
    const nextProduct = products[next];

    document.querySelector(".nav-prev").href =
      `/products/${prevProduct.handle}?collection=${collectionHandle}`;

    document.querySelector(".nav-next").href =
      `/products/${nextProduct.handle}?collection=${collectionHandle}`;
  }

  await getAllProducts();
  setNavigation();

});

// =============================================cus-tabs-products-sec===============================

document.addEventListener('DOMContentLoaded', initTabs);
window.addEventListener('resize', debounce(initTabs, 300));
function initTabs(){
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const tabs = document.querySelectorAll('.cus-led-pr-tbs--tab');
  const contents = document.querySelectorAll('.cus-led-pr-tbs--content');
  const drawer = document.querySelector('.cus-mob-drawer');
  const overlay = document.querySelector('.cus-mob-drawer-overlay');
  const drawerContent = document.querySelector('.cus-mob-drawer-content');
  const drawerTabs = document.querySelector('.cus-mob-drawer-tabs');
  const closeBtn = document.querySelector('.cus-mob-drawer-close');

  if(!tabs.length) return;

  drawerTabs.innerHTML = '';

  const wrapper = document.querySelector('.cus-led-pr-tbs--content-wrapper');
  contents.forEach(el => wrapper.appendChild(el));
  if(!isMobile){

    tabs.forEach(tab => {
      tab.onclick = null;
      tab.addEventListener('click', function(){
        const tabID = this.getAttribute('data-tab');

        tabs.forEach(t=>t.classList.remove('active'));
        contents.forEach(c=>c.classList.remove('active'));

        this.classList.add('active');
        document.getElementById(tabID).classList.add('active');
      });
    });

    return;
  }
  contents.forEach(el => drawerContent.appendChild(el));
  tabs.forEach(tab => {
    const tabId = tab.getAttribute('data-tab');

    const btn = document.createElement('button');
    btn.textContent = tab.textContent;
    btn.dataset.tab = tabId;
    drawerTabs.appendChild(btn);

    tab.onclick = null;
    tab.addEventListener('click', () => {
      openDrawer();
      setActive(tabId);
    });

    btn.addEventListener('click', () => {
      setActive(tabId);
    });

  });
  function setActive(id){
    contents.forEach(c => c.classList.remove('active'));
    const el = document.getElementById(id);
    if(el) el.classList.add('active');

    drawerTabs.querySelectorAll('button').forEach(b => b.classList.remove('active'));
    drawerTabs.querySelector(`[data-tab="${id}"]`)?.classList.add('active');
  }
  function openDrawer(){
    drawer.classList.add('open');
    overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(){
    drawer.classList.remove('open');
    overlay.classList.remove('show');
    document.body.style.overflow = '';
  }
  closeBtn.onclick = closeDrawer;
  overlay.onclick = closeDrawer;

}

function debounce(func, delay){
  let timeout;
  return function(){
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  }
}
